<style scoped>
.header-container {
    width: 100%;
    height: 5vh;
    position: relative;
    margin: 0;
    border: 0;
    display: flex;
    align-items: center;
    justify-content: space-between; /* 让图片和标题之间有一些间距 */
    padding: 0; /* 增加一些内边距，使内容不紧贴边缘 */
    background:linear-gradient(to right, #253a29, #309a28); /* 添加渐变色背景 */
}

.logo {
    height: 100%;
    max-width: 200px; /* 限制图片的最大宽度，防止图片过大 */
}
.section-title{
    margin: 0; /* 去除标题的默认外边距 */
    font-size: 2.0rem; /* 设置标题的字体大小 */

    color: #e8f4dd; /* 设置标题的颜色 */
}
.company-name {
    margin: 0; /* 去除标题的默认外边距 */
    font-size: 1.0rem; /* 设置标题的字体大小 */

    color: #e4eaee; /* 设置标题的颜色 */
    padding: 10px;
}

.login-state{
    font-size: 0.8rem;
    color:#9a2d34;
}
.clickable{
    cursor: pointer;
    color:yellow;
    font-size: 0.8rem;
}

.button-group {
    display: flex;
    gap: 10px; /* 按钮之间的间距 */
    justify-content: center;
    align-items: center;
}

.nav-button {
    padding: 8px 16px;
    font-size: 1rem;
    background-color: #007bff; /* 按钮背景颜色 */
    color: white; /* 按钮文字颜色 */
    border: none;
    border-radius: 4px; /* 按钮圆角 */
    cursor: pointer;
    transition: background-color 0.3s ease; /* 鼠标悬停时的过渡效果 */
}

.nav-button:hover {
    background-color: #0056b3; /* 鼠标悬停时的背景颜色 */
}

/* 对话框样式 */
.password-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1008;
    border: 10px solid rgba(0, 0, 0, 0.1); 
}

.dialog-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.dialog-content {
    position: relative;
    background-color: #f9f9f9;
    padding: 25px;
    border-radius: 8px;
    width: 350px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.dialog-title {
    margin-top: 0;
    margin-bottom: 20px;
    color: #333;
    text-align: center;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    color: #666;
    font-size: 0.9rem;
}

.form-group input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 0.9rem;
}

.btn {
    padding: 10px 15px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9rem;
    transition: background-color 0.3s ease;
}

.cancel-btn {
    background-color: #f4f4f4;
    color: #333;
}

.cancel-btn:hover {
    background-color: #eaeaea;
}

.submit-btn {
    background-color: #007bff;
    color: white;
}

.submit-btn:hover {
    background-color: #0056b3;
}

.dialog-content h2 {
    margin-top: 0;
}

.dialog-content label {
    display: block;
    margin-bottom: 5px;
}

.dialog-content input {
    width: 100%;
    padding: 8px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 3px;
}

.dialog-content .button-group {
    justify-content: flex-end;
}

.error-message {
    color: red;
    font-size: 0.9rem;
    margin-bottom: 10px;
}

.primary-button {
  background-color: #007BFF;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.primary-button:hover {
  background-color: #0056b3;
}

</style>

<template>
    <div class="header-container">
        <img class="logo" src="../assets/Logo1.png" alt="logo">
        <!-- <div class="button-group">
            <button class="nav-button">首页</button>
            <button class="nav-button">关于我们</button>
            <button class="nav-button">产品与服务</button>
            <button class="nav-button">联系我们</button>
        </div>  -->
        <h1 class="section-title">田巡小工具{{ txType }}</h1>

        <h1 class="company-name">北京新益安地理信息技术有限公司(tel:15810675393)<br><span class="login-state">您好，{{username}}。&nbsp;&nbsp;<a @click="logout" class="clickable">{{ isLoggedin?"注销":"登录" }}</a></span>
            &nbsp;&nbsp;<span><a class="clickable" @click="showPasswordDialog = true">修改密码</a></span>&nbsp;&nbsp;<span><a class="clickable" @click="{isEWMShow = true;}">小程序二维码</a></span>
            &nbsp;&nbsp;<span><a href="/public/北京市昌平区耕地标准图则V2.0.pdf" target="_blank" class="clickable">耕地验收样例图则</a></span>
        </h1>        
    </div>
    <!-- 修改密码对话框 -->
    <div v-if="showPasswordDialog" class="password-dialog">
        <div class="dialog-overlay" @click="showPasswordDialog = false"></div>
        <div class="dialog-content">
            <h2 class="dialog-title">修改密码</h2>
            <form @submit.prevent="submitPasswordForm">
                <div class="form-group">
                    <label for="oldPassword">原密码:</label>
                    <input type="password" id="oldPassword" v-model="passwordForm.oldPassword" required>
                </div>
                <div class="form-group">
                    <label for="newPassword">新密码:</label>
                    <input type="password" id="newPassword" v-model="passwordForm.newPassword" required>
                </div>
                <div class="form-group">
                    <label for="confirmPassword">确认新密码:</label>
                    <input type="password" id="confirmPassword" v-model="passwordForm.confirmPassword" required>
                </div>
                 <!-- 添加提示信息 -->
                <p v-if="hasMsg" class="error-message">{{msg}}</p>
                <div class="button-group">
                    <button type="button" @click="showPasswordDialog = false" class="btn cancel-btn">取消</button>
                    <button type="submit" class="btn submit-btn">确定</button>
                </div>
            </form>
        </div>
    </div>
    <div v-if="isEWMShow" class="password-dialog">
        <div class="dialog-overlay" @click="showPasswordDialog = false"></div>
        <div class="dialog-content">
            <h2 class="dialog-title">田巡二维码</h2>
            <div>
                <img src="@/assets/ewm.jpg" alt="二维码" style="width: 300px;height: 300px;">
            </div>           
            <button class="primary-button" @click="{isEWMShow=false;}">确定</button>
        </div>
    </div>
    
</template>

<script>
import axios from 'axios';
const instance = axios.create();
instance.interceptors.request.use(config=>{
  const token = localStorage.getItem('token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
},error=>{
  return Promise.reject(error);
});

export default {
    name: 'MyHeader',
    data(){
        return {
            username:"游客",
            isLoggedin:false,
            showPasswordDialog: false,
            passwordForm: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            hasMsg: false,
            msg:'两次输入的新密码不一致，请重新输入。',
            serverAddress:process.env.TX_SERVER_ADDRESS_BACK,
            txType:process.env.TX_TYPE||'',
            isEWMShow:false,
        }
    },
    mounted(){
        this.username = localStorage.getItem('userName');
        this.isLoggedin = localStorage.getItem('isLoggedIn');
    },
    methods:{
        logout(){
            localStorage.clear();
            this.$router.push('/LoginPage');
        },
        async submitPasswordForm() {
            // 这里可以添加验证逻辑和提交表单的代码
            if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
                this.hasMsg = true;
                this.msg = '两次输入的新密码不一致，请重新输入。';
                return;
            }
            const userID = localStorage.getItem('userID');           
            try{
                const res = await instance.post(this.serverAddress + "/api/resetPassword",{
                userID:userID,
                oldPassword:this.passwordForm.oldPassword,
                newPassword:this.passwordForm.newPassword,
                });
                if (res.status === 200) {
                    // 密码修改成功，显示提示信息
                    this.hasMsg = true;
                    this.msg = res.data.msg;
                    // 延时 2 秒后关闭对话框
                    setTimeout(() => {
                        this.showPasswordDialog = false;
                        // 清空表单
                        this.passwordForm = {
                            oldPassword: '',
                            newPassword: '',
                            confirmPassword: ''
                        };
                        // 隐藏提示信息
                        this.hasMsg = false;
                    }, 2000);
                } else {
                    // 密码修改失败，显示错误信息
                    this.hasMsg = true;
                    this.msg = res.data.msg;
                }
            }catch(error){
                console.log("修改密码出错："+error);
                this.hasMsg = true;
                this.msg = '请求出错，请稍后重试。';
            }
            
        }
    }
}    
</script>
